import React from "react";

export default function ImageSkeleton() {
  return (
    <div className="w-full mx-auto h-52 md:h-[500px] bg-gray-200 animate-pulse">
      <div className="flex justify-center items-center h-full"></div>
    </div>
  );
}
